import { useMutation } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";

export const useJoinAnalyticsPilotMutation = (customerDomain: string | undefined) => {
  const client = useAxios();
  return useMutation({
    mutationKey: ["analytics-pilot", "join", customerDomain],
    mutationFn: async () => {
      if (!customerDomain) {
        throw new Error("Missing customer domain");
      }
      await client.post(`/${customerDomain}/analytics-pilot/api/join`);
    },
  });
};
